<div class="">
  <app-loading [exibir]="carregando"></app-loading>
  <div *ngIf="!carregando">
    <div class="row mt-2">
    </div>
    <div class="row">
      <div class="col-8 tirap">
        <button [disabled]="!filtroconsolidado" pButton type="button"
          label="{{'estoque.pcaDashboard.abaPcaConsolidado' | translate}}" (click)="consolidado($event)"
          class="p-button-sm p-button-secondary p-button-outlined botaoc"></button>
        <button [disabled]="!filtropecas" pButton type="button" label="{{'estoque.pcaDashboard.abaPecas' | translate}}"
          (click)="pecas($event)" class="p-button-sm p-button-secondary p-button-outlined botaoc"></button>
        <button [disabled]="!filtroroupas" pButton type="button"
          label="{{'estoque.pcaDashboard.abaRoupas' | translate}}" (click)="roupas($event)"
          class="p-button-sm p-button-secondary p-button-outlined botaoc"></button>
        <button [disabled]="!filtroacessorios" pButton type="button"
          label="{{'estoque.pcaDashboard.abaAcessorios' | translate}}" (click)="acessorios($event)"
          class="p-button-sm p-button-secondary p-button-outlined botaoc"></button>
      </div>
      <div class="col-4">
        <button class="btn btn-outline-secondary btn-sm mb-2 float-right" (click)="exportarExcel()">
          <em class="fa fa-download fa-xs"></em>
          Export Excel
        </button>
      </div>
    </div>
    <div class="content">
      <p-table #dt dataKey="id" [value]="tempDados.dados" selectionMode="single" styleClass="p-datatable-responsive-demo
          p-datatable-striped
          p-datatable-sm" [columns]="selectedColumns" [columns]="cols" [value]="rows" [autoLayout]="true"
        id="excel-table" class="style">
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <col style="width: 150px;">
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th [translate]="getTranslate(col.header)" [pSortableColumn]="col.field" class="text-center" [ngClass]="AlteraHeader(col.header)"
              *ngFor="let col of columns">
              {{col.header}}
              <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dados let-columns="columns">
          <tr>
            <ng-container *ngFor="let col of columns">
              <td class="text-center">
                <div [translate]="getTranslate(dados[col.field])">
                  {{ col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field] }}
                  <ng-container *ngIf="col.field === 'nome_dealer'"></ng-container>
                </div>
              </td>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr class="styleFooter">
            <td [translate]="getTranslate(nomeDealer)" class="text-center">
            </td>
            <td class="text-center">
              {{quantidadeDealer }}
            </td>
            <td class="text-center">
              {{totalCurvaA | currency: '  '}}
            </td>
            <td class="text-center">
              {{totalPercentualA | percent: '1.0-0'}}
            </td>
            <td class="text-center">
              {{totalCurvaB | currency: '  '}}
            </td>
            <td class="text-center">
              {{totalPercentualB | percent: '1.0-0'}}
            </td>
            <td class="text-center">
              {{totalCurvaC | currency: '  '}}
            </td>
            <td class="text-center">
              {{totalPercentualC | percent: '1.0-0'}}
            </td>
            <td class="text-center">
              {{totalCurvaD | currency: '  '}}
            </td>
            <td class="text-center">
              {{totalPercentualD | percent: '1.0-0'}}
            </td>
            <td class="text-center">
              {{totalOutros | currency: '  '}}
            </td>
            <td class="text-center">
              {{totalPercentualOutros | percent: '1.0-0'}}
            </td>
            <td class="text-center">
              {{totalCurvaAbc | currency: '  '}}
            </td>
          </tr>          
        </ng-template>       
      </p-table>      
        <hr>
        <div *ngIf="marcas == 'Triumph' || marcas == 'NBS'" class="row">
          <div class="col-8">
            <legend translate>{{'estoque.curvaABC.legenda1'}}</legend>
            <legend translate>{{'estoque.curvaABC.legenda2'}}</legend>
            <legend translate>{{'estoque.curvaABC.legenda3'}}</legend>            
          </div>
        </div>      
    </div>
  </div>
</div>
